import React from 'react';
import { DownloadIcon, SearchIcon, TrendingDownIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: 1,
    icon: DownloadIcon,
    title: 'Descarga el protocolo y las plantillas',
    description: 'Acceso instantáneo a todos los recursos digitales inmediatamente después del pago.'
  }, {
    number: 2,
    icon: SearchIcon,
    title: 'Auditoría de 15 minutos de tu despensa',
    description: 'Realiza un análisis rápido de tus hábitos actuales de compra y consumo.'
  }, {
    number: 3,
    icon: TrendingDownIcon,
    title: 'Aplica el sistema y recupera tu inversión',
    description: 'Usa el sistema en tu próxima ida al supermercado y recupera tu inversión en la primera boleta.'
  }];
  return <section className="w-full bg-[#1a2332] py-16 px-4" data-id="element-139">
      <div className="max-w-6xl mx-auto" data-id="element-140">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-141">
          Cómo funciona
        </h2>

        <div className="grid md:grid-cols-3 gap-8 md:gap-4" data-id="element-142">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="relative" data-id="element-143">
                <div className="bg-[#243447] rounded-lg p-8 text-center h-full" data-id="element-144">
                  <div className="flex justify-center mb-4" data-id="element-145">
                    <div className="w-16 h-16 rounded-full bg-[#fbbf24] flex items-center justify-center text-[#1a2332] text-2xl font-bold" data-id="element-146">
                      {step.number}
                    </div>
                  </div>

                  <div className="flex justify-center mb-4" data-id="element-147">
                    <Icon className="w-12 h-12 text-[#fbbf24]" data-id="element-148" />
                  </div>

                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-149">
                    {step.title}
                  </h3>

                  <p className="text-gray-300 leading-relaxed" data-id="element-150">
                    {step.description}
                  </p>
                </div>

                {index < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-2 transform -translate-y-1/2 translate-x-full" data-id="element-151">
                    <div className="w-8 h-0.5 bg-[#fbbf24]" data-id="element-152"></div>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}